/**
 * TEMPLATE-UX-1 — linear phases process map (list DTO only).
 * Gate markers are suppressed (TEMPLATE-CENTER-REDESIGN-1 / PLATFORM-TRUTH-SURVEY-1):
 * armed-gate claims are not safe to surface until workspace LEAN enforcement is fixed.
 */
import type { TemplateDto } from '../templates.api';
import { templatePhaseList } from '../template.mapper';

interface TemplateProcessMapProps {
  template: TemplateDto;
}

export function TemplateProcessMap({
  template,
}: TemplateProcessMapProps): JSX.Element | null {
  const phases = templatePhaseList(template);
  if (phases.length === 0) return null;

  return (
    <div data-testid="template-process-map" className="space-y-2">
      <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-500">
        Process
      </h3>
      <ol className="flex flex-wrap items-center gap-y-2">
        {phases.map((phase, index) => {
          const isLast = index === phases.length - 1;
          return (
            <li
              key={`${phase.reportingKey ?? phase.name}-${index}`}
              className="flex items-center"
              data-testid={`template-process-phase-${index}`}
            >
              <span
                className="inline-flex max-w-[9rem] truncate rounded-md border border-slate-200 bg-white px-2 py-1 text-xs font-medium text-slate-800"
                title={phase.name}
              >
                {phase.name}
              </span>
              {!isLast ? (
                <span className="mx-0.5 h-px w-3 bg-slate-300" aria-hidden />
              ) : null}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
